import { Component, Inject, OnInit } from '@angular/core';
import { PesquisaFiltro } from './pesquisa-filtro.model';
import { NotaFiscal } from '@app/models/nota-fiscal.model';
import { UtilitarioService } from '@app/services/utilitario.service';
import { ToastrService } from 'ngx-toastr';
import { NotaFiscalService } from '@app/services/nota-fiscal.service';
import { ConsultasService } from '@app/services/consultas.service';
import { Paginacao } from '@app/models/util/paginacao';
import { TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

import debounce from '@app/utils/debounce';
import { ClasseImposto } from '@app/models/classe-imposto.model';
import { IdDescricao } from '@app/models/util/id-descricao';
import { CancelamentoModel } from './cancelamento.model';

@Component({
  selector: 'app-nota-fiscal-lista',
  templateUrl: './nota-fiscal-lista.component.html'
})
export class NotaFiscalListaComponent implements OnInit {

  
  @ViewChild('modalStatusNFSe', {static: true}) modalStatusNFSe: TemplateRef<any>;
  @ViewChild('modalCancelarNFSe', {static: true}) modalCancelarNFSe: TemplateRef<any>;

  pesquisa: PesquisaFiltro = new PesquisaFiltro();
  cancelamento: CancelamentoModel = new CancelamentoModel();
  lstNotasFiscais: NotaFiscal[] = [];
  lstClasseImposto: ClasseImposto[] = [];
  lstMotivos: IdDescricao[] = [];
  lstParticipante = [];
  _debounce: any;
  _pesquisa: any;

  lstErros: string[] = [];
  paginacao: Paginacao = new Paginacao();

  notaStatus: NotaFiscal = new NotaFiscal();
  bsModalRef: BsModalRef;

  aguardando: boolean = false;
  notaEncontrada: boolean = false;

  constructor(
    private notaFiscalServico: NotaFiscalService,
    private modalService: BsModalService,
    private consultasService: ConsultasService,
    @Inject(ToastrService) public toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.pesquisa.DataInicial = UtilitarioService.retornaDataAtualMaisDiasISO(-15);
    this.pesquisa.DataFinal = UtilitarioService.retornaDataAtualMaisDiasISO(0);
    this.pesquisa.Discriminacao = '';
    
    this.paginacao.itensPorPagina = 20;

    this.pesquisar();
  }

  pesquisar(pagina: number = 1){
    this.aguardando = true;
    this.pesquisa.Pagina = pagina;
    this.notaFiscalServico.lista(this.pesquisa).subscribe((data) => {
      this.lstNotasFiscais = data.Dados;
      this.paginacao.totalDeItens = data.TotalDados;
      this.aguardando = false;
    },
    () => {
      this.toastr.warning("Realize a pesquisa novamente!");
      this.aguardando = false;
    });
  }
  
  consultarNFSe(uuid: string, id: number){
    this.notaFiscalServico.consultar(uuid, id).subscribe((data) => {
      this.notaStatus = data;
      this.pesquisar(this.paginacao.paginaAtual);
      this.bsModalRef = this.modalService.show(this.modalStatusNFSe, { class: 'modal-sm' });
    });
  }

  cancelarNota(){
    this.aguardando = true;
    this.notaFiscalServico.cancelar(this.cancelamento).subscribe(() => {
      this.toastr.success("Nota cancelada com sucesso");
      this.pesquisar();
      this.aguardando = false;
      this.fecharModal();
    }, 
    () => {
      this.toastr.info("Não foi possível cancelar a nota");
      this.aguardando = false;
    })
  }

  public ngxselect_typed(value: any): void {
    this.lstParticipante = [{ id: -1, text: 'Pesquisando...' + value, disabled: true }];
    this._pesquisa = value;
    if (!this._debounce) {
      this._debounce = debounce(() => {
        this.consultasService.consultar('PARTICIPANTE', this._pesquisa).toPromise().then(data => {
          this.lstParticipante = data;
        });
      }, 500);
    }
    this._debounce();
  }

  abreModalCancelamento(uuid: string, id: number){
    this.populaMotivosSubstituicaoCancelamento();
    this.cancelamento.Id = id;
    this.cancelamento.UUID = uuid;
    this.bsModalRef = this.modalService.show(this.modalCancelarNFSe, { class: 'modal-sm' })
  }

  fecharModal(){
    this.bsModalRef.hide();
  }

  public pageChanged(event: any): void {
    this.pesquisar(event.page);
  }

  capsPrimeiraLetra(palavra: string){
    return palavra.charAt(0).toUpperCase() + palavra.slice(1);
  }

  populaMotivosSubstituicaoCancelamento(){
    this.lstMotivos[0] = {Id: 1 , Descricao: 'Erro na emissão', Extra1: null, Extra2: null, Extra3: null, Extra4: null };
    this.lstMotivos[1] = {Id: 2 , Descricao: 'Serviço não prestado', Extra1: null, Extra2: null, Extra3: null, Extra4: null };
    this.lstMotivos[2] = {Id: 4 , Descricao: 'Duplicidade da nota', Extra1: null, Extra2: null, Extra3: null, Extra4: null };
  }

}
